import AddToPhotosIcon from '@mui/icons-material/AddToPhotosRounded';
import AutoStoriesIcon from '@mui/icons-material/AutoStoriesRounded';
import BeenhereIcon from '@mui/icons-material/BeenhereRounded';
import HomeIcon from '@mui/icons-material/HomeRounded';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOverRounded';
import SettingsIcon from '@mui/icons-material/SettingsRounded';
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremiumRounded';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import * as Space from 'react-spaces';
import { NavigationLink } from '../../Contexts/BlackListLinkContextProvider/BlackListLinkContext';
import useBlackListLinks from '../../Contexts/BlackListLinkContextProvider/useBlackLinstLinks';
import useHistory from '../../Hooks/useHistory/useHistory';
import StyledBox from './styles';

export default function QuickAccessBar() {
  const { links } = useBlackListLinks();
  const { t } = useTranslation();
  const { t: tPerformance } = useTranslation('performance');
  const { newHistoryState } = useHistory();

  if (links.length === Object.keys(NavigationLink).length) return null;
  return (
    <Space.Left size={36}>
      <StyledBox>
        {!links.includes(NavigationLink.Home) && (
          <NavLink
            to="/home"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('app-bar.home')}
            state={newHistoryState}
          >
            <HomeIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Cards) && (
          <NavLink
            to="/cards"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('home-page.cards.title')}
            state={newHistoryState}
          >
            <StickyNote2RoundedIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Commands) && (
          <NavLink
            to="/commands"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('home-page.commands.title')}
            state={newHistoryState}
          >
            <RecordVoiceOverIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Compliance) && (
          <NavLink
            to="/compliance"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('home-page.compliance.title')}
            state={newHistoryState}
          >
            <BeenhereIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Requests) && (
          <NavLink
            to="/requests"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('menu.content-request')}
            state={newHistoryState}
          >
            <AddToPhotosIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Performance) && (
          <NavLink
            to="/performance"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={tPerformance('title')}
            state={newHistoryState}
          >
            <WorkspacePremiumIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Sessions) && (
          <NavLink
            to="/sessions"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('menu.sessions')}
            state={newHistoryState}
          >
            <AutoStoriesIcon />
          </NavLink>
        )}
        {!links.includes(NavigationLink.Settings) && (
          <NavLink
            to="/settings"
            className={({ isActive, isPending }) => clsx({ isPending, isActive: isActive && !isPending })}
            title={t('menu.settings')}
            state={newHistoryState}
          >
            <SettingsIcon />
          </NavLink>
        )}
      </StyledBox>
    </Space.Left>

  );
}
